import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetCountry } from "../queries/countries";
import { ENTITY } from "../constants";

export const CountryBreadcrumb = ({ match }) => {
  // Entity
  const { COUNTRY } = ENTITY;

    const {
      data: country,
      isLoading,
      isError,
      error,
    } = useGetCountry(match.params.countryId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (country) {
      return <span>{trimString(country[COUNTRY.nameField], 20)}</span>;
    }
  
    return null;
  };